import UserInfo from '../model/userinfo';
export const GET_FOLLOW = 'GET_FOLLOW';
export const GET_FOLLOWERS_LIST = 'GET_FOLLOWERS_LIST';

const mapFollowUsers = (ress) => {
  const data = [];
  const seen = new Set();
  const rows = Array.isArray(ress) ? ress : [];
  rows.forEach(row => {
    const publicId = row.public_id || row.id;
    if (!publicId || seen.has(String(publicId))) return;
    seen.add(String(publicId));
    data.push(new UserInfo(
      publicId,
      publicId,
      row.email,
      row.postition || row.country,
      row.job,
      row.hobby,
      row.img,
      row.big_img,
      row.first_name,
      row.following,
      row.vleading,
      row.bio,
      row.age,
      row.story,
      row.followType === 'n' || row.notifyAll
    ));
  });
  return data;
};

export const  get_following = () =>{
  return async (dispatch,getState) =>{
      const userid = getState().authReduse.id;
    const res= await fetch(`/api/followship/lead/${userid}`);
     const ress = await res.json();
    dispatch({type:GET_FOLLOWERS_LIST,data:mapFollowUsers(ress)})
  }
}
export const  get_follow = () =>{
  return async (dispatch,getState) =>{
      const userid = getState().authReduse.id;
      if (!userid) return;
    const res= await fetch(`/api/followship/follow/${userid}`);
     const ress = await res.json();
    dispatch({type:GET_FOLLOW,data:mapFollowUsers(ress)})
  }
}
